import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Image from "next/image";
import { useConnect } from "wagmi";
import { WalletConnectLogo } from "../../components/theme/custom-svgs";

import type { JSX } from "react";

export function SignInWithEthereumMenu({
    signIn,
    reset,
}: {
    signIn: (connectorIndex: number, email?: string) => Promise<void>;
    reset: () => void;
}): JSX.Element {
    const handleWalletSelect = async (connectorIndex: number) => {
        // reset localError from useSign & reset signMessage, since its error doesnt reset upon a new attempt
        reset();
        await signIn(connectorIndex);
    };

    const { connectors } = useConnect();

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button className="w-full">Choose Wallet</Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="center" className="min-w-[280px]">
                    {connectors.flatMap((connector, index) => {
                        if (
                            connector.id === "magic" ||
                            connector.id === "magic-aa" ||
                            connector.id === "baseAccountSDK"
                        )
                            return [];

                        return (
                            <div key={index}>
                                <DropdownMenuItem
                                    onClick={() => {
                                        void handleWalletSelect(index);
                                    }}
                                >
                                    {connector.icon != null && (
                                        <Image
                                            width={20}
                                            height={20}
                                            src={connector.icon}
                                            alt={"Icon"}
                                            className="mr-2 size-5"
                                        />
                                    )}
                                    {connector.id === "walletConnect" && (
                                        <div className="mr-2 size-5">
                                            <WalletConnectLogo />
                                        </div>
                                    )}

                                    <span>{connector.name}</span>
                                </DropdownMenuItem>
                            </div>
                        );
                    })}
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
}
